import { AxiosError } from 'axios';
import { useState } from 'react';

import { RouteAnalysisChartData } from '../../../models/dashboard/dashboard/route-analysis-data';
import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import { routeAnalysisDataActions } from '../../../redux/slices/routeAnalysisDataSlice';
import { useAppDisPatch } from '../../../redux/store';
import useHttps from '../../useHttps';

const useRouteAnalysisChart = () => {
    const request = useHttps();
    const dispatch = useAppDisPatch();
    const [loading, setLoading] = useState(false);

    const onRouteAnalysisChartError = (err: AxiosError<ErrorHttpResponse>) => {
        console.error(err?.response?.data?.message ?? 'Something went wrong while retrieving route analysis chart data');
    };

    const onRouteAnalysisChartSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<RouteAnalysisChartData[]>) => {
        dispatch(routeAnalysisDataActions.setRouteAnalysisData(data));
    };

    const routeAnalysisChartData = async () => {
        const url: HttpConfig = {
            url: `ba/v1/dashboard/route-analysis`,
            method: 'get',
        };

        return request(url, onRouteAnalysisChartSuccess, setLoading, onRouteAnalysisChartError);
    };

    return { routeAnalysisChartData, loading };
};

export default useRouteAnalysisChart;


